const _debuggingEnabled = import.meta.env.VITE_APP_DEBUGGING_ENABLED
const _appName = 'hyve-leasing-calculator'

function createTag(tag: string | null): string {
  return `[${_appName}${tag ? '::' + tag : ''}]`
}

export function log(tag: string | null, ...messages: any[]) {
  if (_debuggingEnabled) console.log(createTag(tag), ...messages)
}

export function logFunction<P, R>(name: string, fn: (...params: P[]) => R, ...params: P[]): R {
  const result = fn(...params)
  log(name, `params:`, ...params, 'result:', result)
  return result
}

export function logError(tag: string | null, error: Error) {
  if (_debuggingEnabled) console.error(createTag(tag), error)
}

export function logWarn(tag: string | null, ...messages: any[]) {
  if (_debuggingEnabled) console.warn(createTag(tag), ...messages)
}
